module.exports = {
  CAD: "CAD",
  CAM: "CAM",
  GCODE: "GCODE",
  TOOLPATH: "TOOL PATH",
};
